module.exports = __webpack_public_path__ + "img/symbol_7.6c9e7de6.png";